export interface MixpanelGlobalState {
    seasonId: string;
    stage: string; teamId: string;
}

export interface MixpanelLiveGamesInfo {
    affiliatedTeamHasLiveGame: boolean;
    selectedTeamHasLiveGame: boolean;
}
